$(function(){
    if($('.list-items').length>0) {
        favorites.init();
    }
});

var favorites = {
    init: function() {
        console.log('favorites init')
        $('.list-items').on('click', '.favorite-badge', favorites.onClick);
        if($('#profileFavorites').length>0) {
            $('#loadButton').click();
        }
    },
    onClick: function(event) {
        var badge;
        if($(event.target).data('id')) {
            badge = $(event.target);
        } else {
            badge = $(event.target).closest('.favorite-badge');
        }
        var id = badge.data('id');
        var action;
        if(badge.hasClass('is_favorite')) {
            action = 'remove';
        } else {
            action = 'add';
        }
        console.log('favorite', id);

        $.ajax({
            url: '/ajaxRequest/favorites/' + action,
            method: 'post',
            dataType: "json",
            data: {'creation_id': id},
            success: function( resp ) {
                console.log(resp);
                if(resp.data && typeof resp.data.is_favorite !== 'undefined') {
                    if(resp.data.is_favorite) {
                        badge.addClass('is_favorite');
                    } else {
                        badge.removeClass('is_favorite');
                    }
                    if($('#profileFavorites').length>0) {
                        $('#loadButton').data('pagecnt', 0);
                        $('#loadButton').click();
                    }
                }
            }
        });

    }
};